import { j as t } from "../../../../jsx-runtime-B3iL8JI7.js";
import { useRef as N, useEffect as a } from "react";
import { format as k } from "date-fns";
import { faCaretUp as v, faCaretDown as C, faCaretLeft as M, faCaretRight as y } from "@fortawesome/pro-solid-svg-icons";
import "../../../atoms/Button/Button.styles.js";
import "@fortawesome/pro-duotone-svg-icons";
import o from "../../../atoms/Icon/Icon.js";
import "../../../../tailwindConfig/bclTwMerge.js";
import "@radix-ui/react-checkbox";
import "../../../atoms/Checkbox/Checkbox.styles.js";
import "../../../atoms/Loader/SYFLoader/SyfLoader.js";
import "../../../atoms/ProgressIndicator/ProgressIndicator.styles.js";
import "@radix-ui/react-select";
import "../../../atoms/TextField/TextField.styles.js";
import "../../../atoms/TextLink/TextLink.styles.js";
import "../../../atoms/Chip/Chip.styles.js";
import "@radix-ui/react-radio-group";
import "../../../atoms/RadioItem/RadioItem.styles.js";
const O = ({
  date: i,
  decreaseMonth: m,
  increaseMonth: l,
  prevMonthButtonDisabled: f,
  nextMonthButtonDisabled: c,
  decreaseYear: p,
  increaseYear: x,
  prevYearButtonDisabled: u,
  nextYearButtonDisabled: d,
  isYearSelect: r,
  setIsYearSelect: h,
  onDateChange: n
}) => {
  const e = N(null);
  a(() => {
    n && n(i);
  }, [i]), a(() => {
    e.current && e.current.focus();
  }, []);
  const j = (s) => {
    s.preventDefault(), r ? p() : m();
  }, b = (s) => {
    s.preventDefault(), r ? x() : l();
  };
  return /* @__PURE__ */ t.jsxs("div", { className: "flex h-full items-center justify-between pl-4 pr-2", children: [
    /* @__PURE__ */ t.jsxs("div", { className: "flex items-center", children: [
      /* @__PURE__ */ t.jsx("p", { className: "font-sans text-caption-md font-medium", children: k(i, "MMMM yyyy") }),
      /* @__PURE__ */ t.jsx(
        "button",
        {
          ref: e,
          "aria-label": r ? "Day Picker" : "Year Picker",
          className: "p-4",
          onClick: () => h(!r),
          children: r ? /* @__PURE__ */ t.jsx(o, { icon: v }) : /* @__PURE__ */ t.jsx(o, { icon: C })
        }
      )
    ] }),
    /* @__PURE__ */ t.jsxs("div", { className: "flex", children: [
      /* @__PURE__ */ t.jsx(
        "button",
        {
          "aria-label": r ? "Previous Years" : "Previous Month",
          className: "p-4",
          disabled: r ? u : f,
          onClick: j,
          children: /* @__PURE__ */ t.jsx(o, { icon: M })
        }
      ),
      /* @__PURE__ */ t.jsx(
        "button",
        {
          "aria-label": r ? "Next Years" : "Next Month",
          className: "p-4",
          disabled: r ? d : c,
          onClick: b,
          children: /* @__PURE__ */ t.jsx(o, { icon: y })
        }
      )
    ] })
  ] });
};
export {
  O as default
};
